import { createSelector } from "reselect";

const selectPreReq = (state) => state.preReq;
const selectNewReuqest = (state) => state.newReuqest;
// shown_support
export const selectPreReqTypeOfLoad = createSelector(
  selectPreReq,
  (preReq) => preReq.typeOfLoad
);
export const selectPreReqResponseInstantRequestResult = createSelector(
  selectPreReq,
  (preReq) => preReq.response_new_instant_request
);

export const selectPreReqSubmitIsLoading = createSelector(
  selectPreReq,
  (preReq) => {
    // console.log(preReq.submit_isLoading);
    // alert("select loading");
    return preReq.submit_isLoading;
  }
);

export const selectIsPreReqSubmitValid = createSelector(
  selectNewReuqest,
  (newReq) => {
    const {
      source_location,
      destination_location,
      selected_loadType,
      selected_vehicle,
      load_value,
    } = newReq;
    console.log({ newReq });

    const isValid =
      Boolean(load_value) &&
      Boolean(selected_vehicle) &&
      Boolean(source_location) &&
      Boolean(destination_location) &&
      Boolean(selected_loadType);
    return isValid;
  }
);
export const selectShownSupport= createSelector(
  selectPreReq,
  (preReq) => preReq.shown_support
);